import GoRoute from './rental_car_website';

function App() {
  return <GoRoute />;
}

export default App;
